import React from 'react'
import './Footer.css'
import  github from '../../assets/git.png'
import  Linkdin from '../../assets/linkdin.png'
import  Insta from '../../assets/insta.png'
const Footer = () => {
  return (
    <div className='footer'>

      <div className="footer-top">
        <div className="footer-top-left">
          
          <p>I am a full stack developer from India.</p>

        </div>
        <div className="footer-top-right">
          <a href="https://github.com/programmerprashu" target="_blank" rel="noopener noreferrer">
            <img src={github} alt="GitHub" width="50" />
          </a>
          <a href="https://www.linkedin.com/in/prashant-yadav-1b6039260" target="_blank" rel="noopener noreferrer">
            <img src={Linkdin} alt="LinkedIn" width="46" />
          </a>
          <a href="https://instagram.com/programmerprashu" target="_blank" rel="noopener noreferrer">
            <img src={Insta} alt="Instagram" width="44" />
          </a>
        </div>



      </div>
      <hr />
      <div className="footer-bottom">
        <p className="footer-bottom-left">
          &copy; 2025 Prashant Yadav All rights reserved.</p>
        <div className="footer-bottom-right">
          <a href="./Terms.pdf" target='blank'>

          <p>Term of servics</p>
          </a>
          <a href="./PrivacyPolicy.pdf" target='blank'>
          <p>Privacy Policy</p>

          </a>

        </div>

      </div>
    </div>
  )
}

export default Footer
